export const recipientTypeMap = {
  company: "companies",
  contact: "contacts",
};
